export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8919.066eed46.jpg";